// import './debug.css';

import Blogs from "./pages/Blogs";
import Blog from "./pages/Blog";
import Welcome from "./pages/Welcome";
import Router from "./pages/Router";

function App() {
  return (
    <div className="">
      {/* <Welcome /> */}
      {/* <Blogs /> */}
      {/* <Blog /> */}
      <Router />
    </div>
  );
}

export default App;
